import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../pages/homePage.vue'
import { useStore } from '@/store/index';
// 导入主布局
const MainLayout = () => import('../components/mainLayout.vue');
const ProductCenter = () => import('../pages/productCenter/productCenter.vue');
const ProjectCase = () => import('../pages/projectCase.vue');
const Solutions = () => import('../pages/solutions.vue');
const About = () => import('../pages/about.vue');
const CaseDetail = () => import('../pages/components/caseDetail.vue');
const ProductDetail = () => import('../pages/components/productDetail.vue');
const PageDetail = () => import('../pages/productCenter/productCenter.vue');
const MoreView = () => import('@/pages/components/moreView.vue');


const routes = [
  {
    path: '/',
    component: MainLayout, // 使用主布局
    children: [
      { path: '/', component: HomePage, name: '首页' },
      { path: '/contactUs', component: () => import('../pages/contactUs.vue') },
      { path: '/projectCase', component: ProjectCase, name: '智慧农业-项目案例' },
      { path: '/solutions', component: Solutions, name: '智慧农业方案' },
      { path: '/productCenter', component: ProductCenter, name: '产品中心' },
      { path: '/about', component: About },
      { path: '/caseDetail', component: CaseDetail },
      { path: '/productDetail', component: ProductDetail },
      { path: '/moreView', component: MoreView, name: '智慧农业' },
      { path: '/pageDetail', component: PageDetail, name: '产品中心1' },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to , from, savePosition){
    // 如果有保存的位置，则回到保存的位置
    // if(savePosition){
    //   return  savePosition
    // }
    return {left: 0, top: 0}
  },
})

let hasFetchedCategories = false; // 标志变量

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const store = useStore();
  // 将上一级和上上级路由信息存储在全局状态或在每个组件中使用
  // 这里我们可以使用 `from` 来获取上一级路由信息
  const previousRoute = from;
  const previousPreviousRoute = from.name ? from.meta.previousRoute : null;

  // 将路由信息存储在 `meta` 中
  to.meta.previousRoute = previousRoute;
  to.meta.previousPreviousRoute = previousPreviousRoute;

  if (!hasFetchedCategories) {
    store.fetchCategories().then(() => {
      hasFetchedCategories = true
      next();
    }).catch(err => {
      console.log(err);
      next() // 处理错误后仍然允许导航
    })
  } else {
    next()
  }
});

export default router
